import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { Link } from '@treams/treams-routes';

import { IClickableProps } from 'packages/kakapo-ui-kit/types/Button';
import Breakpoint from 'packages/kakapo-ui-kit/helpers/Breakpoint';

interface IProps extends IClickableProps {
	children: ReactNode;
}

const style = css<IProps>`
	background-color: ${(props) => props.theme.colors.white};
	height: 40px;
	width: 40px;
	border-radius: 20px;
	line-height: 50px;
	text-align: center;
	display: inline-block;

	@media screen and (max-width: ${Breakpoint.Medium}) {
		width: 30px;
		height: 30px;
		line-height: 40px;
		border-radius: 15px;

		svg {
			max-width: 12px;
		}
	}
`;

export default styled(Link)`
	${style}
`;
